import { Navigate, Route, Routes } from 'react-router-dom';

import { ChangePasswordPage } from 'modules/change-password/page';
import { ProfilePage } from 'modules/profile/page';
import { UsernamePage } from 'modules/profile/page/UsernamePage';

import { PATH } from 'constants/path';

export const ProfileRoutes = () => {
  return (
    <Routes>
      <Route element={<ProfilePage />}>
        <Route path={`${PATH.USERNAME}`} element={<UsernamePage />} />
        <Route path={`${PATH.PASSWORD}`} element={<ChangePasswordPage />} />
        <Route index element={<Navigate to={PATH.USERNAME} />} />
      </Route>
      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Routes>
  );
};
